import React, { useContext } from 'react';
import { ThemeContext } from './../../../Infrastructure/Context/ThemeContext';
import './Header.scss';
import LineIcon from 'react-lineicons';
import { useHistory } from 'react-router';
var Color = require('color');

const Header = ({ heading, subheading, icon, showClose }) => {
    const context = useContext(ThemeContext);
    const history = useHistory();

    const primaryColor = context.primaryButtonColour || context.iconColour || '#667eea';
    const lighterColor = Color(primaryColor).lighten(0.2).hex();

    return (
        <div className="row no-gutters page-heading text-center text-sm-left">
            <div className="icon">
                <div style={{
                    background: `linear-gradient(135deg, ${primaryColor} 0%, ${lighterColor} 100%)`
                }}>
                    <LineIcon name={icon} />
                </div>
            </div>
            <div className="heading">
                <h1>{heading}</h1>
                {subheading && <p>{subheading}</p>}
            </div>
            {showClose &&
                <div className="close">
                    <button
                        className="close-button"
                        onClick={history.goBack}
                        aria-label="Go back"
                    >
                        <LineIcon name="arrow-left" />
                    </button>
                </div>
            }
        </div>
    );
};

export default Header;